import { gql } from '@apollo/client';

export const FETCH_DELEGANTI = gql`
  query fetchDeleganti($where: FamigliariWhereInput) {
    famigliaris(where: $where) {
      edges {
        node {
          id
          objectId
          defunto_pointer {
            objectId
          }
          org_pointer {
            objectId
          }
          nome
          cognome
          codice_fiscale
          rilasciato
          data_rilascio
          data_nascita
          luogo_nascita
          provincia_luogo_nascita
          grado_parentela
          documento_numero
          documento_riconoscimento
          indirizzo
          rilasciato
          cap
          stato
          telefono
          cellulare
          codice_fiscale
          citta
          email
          sesso
        }
      }
    }
  }
`;
